import { httpInstance } from '@/clients/http.request';
import { urlMailBackend } from '@/helpers';

export const sendFallbackEmail = async ({ id_poliza }) => {
   try {
      await httpInstance.post(`${urlMailBackend}/sendFallbackEmail`, {
         id_poliza,
      });
   } catch (error) {
      console.error('Error al enviar fallback email:', error);
   }
};
